export default __webpack_public_path__ + "static/media/study.28c1f277.svg";